'use client';

import { useEffect } from 'react';

import { useSearchParams } from 'next/navigation';

import { TrackParams, track } from './track';

export function FacebookConversionsAPIClient({ params, eventType }: TrackParams) {
  const searchParams = useSearchParams();

  const email = searchParams.get('email');
  const firstName = searchParams.get('firstName');
  const lastName = searchParams.get('lastName');
  const eventId = searchParams.get('id');

  useEffect(() => {
    track({ params, eventType, email, firstName, lastName, eventId });
  }, [params, eventType, email, firstName, lastName, eventId]);

  return null;
}
